import { VariantResponseDto } from '@tiendanube/common';

export function updateVariantStock(variants: VariantResponseDto[]) {
  return variants.reduce((acc, current) => {
    acc[current.id] = current.stock;
    return acc;
  }, {});
}
